import React from "react";
import Label from "../label/Label";
import Color from "../../styles/Color";
import RequiredStarOther from "../required-star/RequiredStarOther";
import injectSheet from "react-jss";
import classNames from "classnames";

function EditTextAreaElement(props) {
  const {
    maxLength = "500",
    arrangemang,
    name,
    id,
    placeholder,
    disabled,
    handleEventChange,
    rows,
    hideMaxLength = false,
    required = false,
    classes,
    error,
    formClass,
  } = props;

  const value =
    arrangemang && arrangemang[name]
      ? arrangemang[name]
      : props.value
      ? props.value
      : "";

  return (
    <div className={classNames("form-group", formClass)}>
      <div style={{ display: "flex" }}>
        <Label className={required && classes.requiredLabel} {...props} />
        {required && (
          <RequiredStarOther
            className={classes.required}
            description="Obligatorisk fält"
          />
        )}
      </div>
      {required && <div className={classes.errorMessage}>{error}</div>}
      {!value ? null : (
        <div
          style={{
            position: "relative",
            textAlign: "right",
          }}
        >
          {!hideMaxLength && (
            <div
              style={{
                fontSize: "10px",
                position: "absolute",
                right: 0,
                top: "-15px",
                padding: "3px",
              }}
            >
              <span
                style={{
                  color:
                    value.length > maxLength ? Color.Color.red() : "#565867",
                }}
              >
                {value.length}
              </span>
              /{maxLength}
            </div>
          )}
        </div>
      )}
      <textarea
        className="form-control"
        type="text"
        id={id ? id : name}
        maxLength={maxLength}
        placeholder={placeholder}
        name={name}
        value={value}
        disabled={disabled}
        rows={rows ? rows : 3}
        onChange={handleEventChange}
      />
    </div>
  );
}

const styles = {
  required: {
    marginTop: "7px",
  },
  requiredLabel: {
    marginBottom: "0px",
  },
  errorMessage: {
    color: "red",
    textAlign: "left",
    fontSize: "12px",
    minHeight: "15px",
  },
};

export default injectSheet(styles)(EditTextAreaElement);
